(function () {
  function slugify(text) {
    return String(text || '')
      .trim()
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\u4e00-\u9fff]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-{2,}/g, '-');
  }

  function uniqueId(base, used) {
    var id = base || 'section';
    var n = 2;
    while (used[id]) {
      id = base + '-' + n;
      n += 1;
    }
    used[id] = true;
    return id;
  }

  function initLayout(root) {
    var content = root.querySelector('.article-blog__content');
    var tocNav = root.querySelector('[data-blog-toc]');
    var tocList = root.querySelector('[data-blog-toc-list]');
    var progressBar = root.querySelector('[data-blog-progress-bar]');
    if (!content || !tocList) return;

    if (tocList.getAttribute('data-built') === '1') return;
    tocList.setAttribute('data-built', '1');

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    var used = {};
    var items = [];

    headings.forEach(function (heading) {
      var id = heading.id || uniqueId(slugify(heading.textContent), used);
      heading.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = heading.textContent.trim();
      li.appendChild(a);
      tocList.appendChild(li);
      items.push({ el: heading, link: a });
    });

    if (!items.length && tocNav) {
      tocNav.hidden = true;
    }

    function setActive() {
      var active = null;
      var offset = 140;
      for (var i = 0; i < items.length; i++) {
        var top = items[i].el.getBoundingClientRect().top;
        if (top - offset <= 0) active = items[i];
      }
      if (!active && items.length) active = items[0];
      items.forEach(function (item) {
        item.link.classList.toggle('is-active', item === active);
      });
    }

    function setProgress() {
      if (!progressBar) return;
      var doc = document.documentElement;
      var scrollTop = window.pageYOffset || doc.scrollTop || 0;
      var scrollHeight = Math.max(
        doc.scrollHeight,
        document.body ? document.body.scrollHeight : 0
      );
      var winH = window.innerHeight || doc.clientHeight || 1;
      var total = Math.max(scrollHeight - winH, 1);
      var pct = Math.min(100, Math.max(0, (scrollTop / total) * 100));
      progressBar.style.width = pct + '%';
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        setActive();
        setProgress();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    setActive();
    setProgress();
    initSideSwatches(root);
  }

  function initSideSwatches(root) {
    var sidebar = root.querySelector('[data-blog-sidebar]');
    if (!sidebar) return;

    sidebar.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.matches('[data-side-swatch]')) return;

      var item = input.closest('[data-sidebar-item]');
      if (!item) return;

      item.querySelectorAll('.article-blog__swatch').forEach(function (label) {
        label.classList.toggle('is-active', label.contains(input));
      });

      var imageUrl = input.getAttribute('data-image');
      if (!imageUrl) return;
      var img = item.querySelector('.article-blog__side-media img');
      if (img) {
        img.src = imageUrl;
        img.removeAttribute('srcset');
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-article-blog]').forEach(initLayout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelectorAll) {
      event.target.querySelectorAll('[data-article-blog]').forEach(initLayout);
    }
  });
})();
